import axios from 'axios';
import { getApiRoot } from '../../../constants/ParamountReactConstants';
import { UpdateXMLHeaderSettings } from '../../../../types/xml_header_settings';

export function fetchXmlHeaders(brandId: number) {
  return {
    type: 'FETCH_BRAND_ACES_PIES_XML_HEADERS',
    payload: axios.get(`${getApiRoot()}/parents/owners/brands/${brandId}/xml_headers`),
  };
}

export function updateXMLHeaders(updateHeaderValues: UpdateXMLHeaderSettings, brandId: number) {
  return {
    type: 'UPDATE_ACES_PIES_XML_HEADERS',
    payload: axios.patch(
      `${getApiRoot()}/parents/owners/brands/${brandId}/xml_headers`,
      updateHeaderValues
    ),
  };
}
